import React, { memo } from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2, BookOpen } from 'lucide-react';
export function ProductReveal() {
  const tomos = [{
    num: 1,
    title: 'Despertando la Mente',
    desc: 'Memoria, atención, concentración, lenguaje y orientación temporal. El punto de partida ideal para cualquier adulto mayor.',
    theme: 'Memoria'
  }, {
    num: 2,
    title: 'Memorias que Perduran',
    desc: 'Música y memoria, razonamiento lógico, viajes por Argentina, números y cálculo cotidiano.',
    theme: 'Recuerdos'
  }, {
    num: 3,
    title: 'Creatividad y Bienestar',
    desc: 'Imaginación, escritura personal, bienestar emocional, mindfulness y humor.',
    theme: 'Creatividad'
  }, {
    num: 4,
    title: 'Conexiones y Cultura',
    desc: 'Música argentina, gastronomía, historia, geografía, vínculos y juegos de estrategia.',
    theme: 'Cultura'
  }, {
    num: 5,
    title: 'Mente Activa, Cuerpo Presente',
    desc: 'Movimiento consciente, coordinación, sueño, alimentación y rutinas saludables.',
    theme: 'Cuerpo'
  }, {
    num: 6,
    title: 'Mi Mejor Versión',
    desc: 'Repaso de todo el camino, plan personal de estimulación, legado y celebración final.',
    theme: 'Mi Mejor Versión'
  }];
  const features = ['Contenido', 'Actividades listas para usar desde el primer día', 'Espacios para escribir y completar', 'Referencias culturales 100% argentinas', 'Lenguaje simple y letra pensada para adultos mayores', 'Variedad cognitiva: memoria, atención, lenguaje, lógica y creatividad', 'Sin preparación previa ni conocimientos especiales', 'Ideal para usar solo o acompañado', 'Listo para imprimir o usar en celular o tablet'];
  return <section className="py-20 px-4 bg-blue-900 text-white" data-id="element-221">
      <div className="max-w-6xl mx-auto" data-id="element-222">
        <div className="text-center mb-16" data-id="element-223">
          <motion.div initial={{
          opacity: 0,
          scale: 0.9
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} className="inline-block bg-amber-500 text-blue-950 font-bold px-6 py-2 rounded-full mb-6 text-lg" data-id="element-224">
            🏆 MEGAPACK MENTE VIVA™
          </motion.div>
          <h2 className="text-3xl md:text-5xl font-bold mb-6" data-id="element-225">
            6 Tomos + 6 Bonos — 480 páginas — Todo resuelto
          </h2>

          <motion.div initial={{
          opacity: 0,
          scale: 0.92
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} className="relative mx-auto max-w-2xl mt-8" data-id="element-226">
            <div className="absolute inset-0 flex items-center justify-center pointer-events-none" data-id="element-227">
              <div className="w-72 h-72 md:w-96 md:h-96 bg-amber-400/25 rounded-full blur-3xl" data-id="element-228" />
            </div>
            <div className="relative" data-id="element-229">
              <img src="https://cdn.magicpatterns.com/uploads/s9TzaxwyN9bqNtj9G35a1E/PNG.png" alt="Megapack Mente Viva Gold Edition — el pack más completo para adultos mayores" className="w-full drop-shadow-2xl" data-id="element-230" />
            </div>
          </motion.div>

          {/* Visual row of tomos */}
          <div className="flex flex-wrap justify-center gap-3 mt-10" data-id="element-231">
            {tomos.map((t, i) => <div key={i} className="bg-blue-800/50 border border-blue-700 px-4 py-2 rounded-lg text-sm font-medium" data-id="element-232">
                Tomo {t.num}: <span className="text-amber-400" data-id="element-233">{t.theme}</span>
              </div>)}
          </div>
        </div>

        <div className="mb-20" data-id="element-234">
          <h3 className="text-2xl md:text-3xl font-bold text-center mb-10 flex items-center justify-center gap-3" data-id="element-235">
            <BookOpen className="w-8 h-8 text-amber-400" data-id="element-236" />6 TOMOS COMPLETOS
          </h3>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-237">
            {tomos.map((tomo, i) => <motion.div key={i} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: i * 0.1
          }} className="bg-blue-800 rounded-2xl p-6 border border-blue-700 hover:border-amber-400/50 transition-colors" data-id="element-238">
                <div className="text-amber-400 font-bold mb-2" data-id="element-239">
                  Tomo {tomo.num}
                </div>
                <h4 className="text-xl font-bold mb-4 text-white" data-id="element-240">
                  {tomo.title}
                </h4>
                <p className="text-blue-100 leading-relaxed" data-id="element-241">{tomo.desc}</p>
              </motion.div>)}
          </div>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="bg-white text-slate-800 rounded-3xl p-8 md:p-12 max-w-4xl mx-auto shadow-xl" data-id="element-242">
          <h3 className="text-2xl font-bold text-blue-900 mb-8 text-center" data-id="element-243">
            Cada tomo incluye:
          </h3>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-244">
            {features.map((feature, i) => <div key={i} className="flex items-start gap-3" data-id="element-245">
                <CheckCircle2 className="w-6 h-6 text-blue-600 flex-shrink-0 mt-0.5" data-id="element-246" />
                <span className="font-medium" data-id="element-247">{feature}</span>
              </div>)}
          </div>
        </motion.div>
      </div>
    </section>;
}